"use client";

import { router } from "@inertiajs/react";

import { DataTablePagination } from "@/components/data-table-pagination";
import { useDataTable } from "@/hooks/use-data-table";
import { useOrganizationRoutes } from "@/hooks/use-organization-routes";
import { DataTable } from "@/lib/data-table";
import type { PagyMetadata, RansackFilters, Supplier } from "@/types";

import { columns } from "./columns";

interface SuppliersDataTableProps {
  suppliers: Supplier[];
  pagy: PagyMetadata;
  filters: RansackFilters;
}

export function SuppliersDataTable({
  suppliers,
  pagy,
  filters,
}: SuppliersDataTableProps) {
  const routes = useOrganizationRoutes();

  // Use shared data table logic for common operations
  const {
    isLoading,
    handlePageChange,
    handleSortingChange,
    getSortingState,
  } = useDataTable({ filters, pagy, path: routes.suppliers.index() });

  return (
    <div className="space-y-4">
      {/* DataTable */}
      <div className={isLoading ? "opacity-50" : ""}>
        <DataTable
          columns={columns}
          data={suppliers}
          sorting={getSortingState()}
          onSortingChange={handleSortingChange}
          manualSorting={true}
          manualPagination={true}
          pageCount={pagy.pages}
          pagination={false}
          onRowClick={(supplier) => router.visit(routes.suppliers.show(supplier))}
        />
      </div>

      {/* Server-side pagination */}
      <DataTablePagination
        pagy={pagy}
        isLoading={isLoading}
        onPageChange={handlePageChange}
        entityName="proveedores"
      />
    </div>
  );
}
